/* eslint-disable import/extensions */
export { default as CreateIssue } from './CreateIssue.vue';
export { default as IssueRoutedEntity } from './IssueRoutedEntity.vue';
